var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "createaccount") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create_acc",
    "data-name": "create acc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.32,319.57a76.76,76.76,0,0,1,39.26,10.55,77.84,77.84,0,0,1,28.71,28.71,76.84,76.84,0,0,1,10.55,39.25v24.61a28,28,0,0,1-28.12,28.13H243.47a28,28,0,0,1-28.13-28.13V398.08a76.84,76.84,0,0,1,10.55-39.25,77.84,77.84,0,0,1,28.71-28.71,76.76,76.76,0,0,1,39.26-10.55h10a102.3,102.3,0,0,0,85.54,0Zm-52.73-18.75a74.36,74.36,0,0,1-37.79-10,72.88,72.88,0,0,1-27.25-27.25,76.67,76.67,0,0,1,0-75.58,72.88,72.88,0,0,1,27.25-27.25,76.67,76.67,0,0,1,75.58,0A72.88,72.88,0,0,1,411.63,188a76.67,76.67,0,0,1,0,75.58,72.88,72.88,0,0,1-27.25,27.25A74.36,74.36,0,0,1,346.59,300.82ZM581,272.69a9,9,0,0,1,9.37,9.38v18.75a9,9,0,0,1-9.37,9.37h-37.5v37.5a9,9,0,0,1-9.38,9.38H515.34a9,9,0,0,1-9.37-9.38v-37.5h-37.5a9,9,0,0,1-9.38-9.37V282.07a9,9,0,0,1,9.38-9.38H506v-37.5a9,9,0,0,1,9.37-9.37h18.75a9,9,0,0,1,9.38,9.37v37.5Z",
    fill: "#3fa9f5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.400d6db448f83b1dd494cb1ce000458a.svg";
export { ForwardRef as ReactComponent };